import React, { useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined, DeleteOutlined } from "@ant-design/icons";
import { Layout, Col, Row, Select, InputNumber } from "antd";
import { Button, Card, Form, Spin, Badge, Avatar, Input } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { CREATE_QR_SHARING, IMAGE_BASE_URL } from "../../constants/api";
import ImageSelect from "../images/ImageSelect";

function QrSharingAdd() {
  const { Content } = Layout;
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loding, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // For Image Selection
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedFileValue, setSelectedFileValue] = useState(null);

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  const handleDialogOk = (selectedImage) => {
    if (selectedImage.length > 0) {
      setSelectedImage(selectedImage[0].id);
      setSelectedFileValue(selectedImage[0].filePath);
      form.setFieldsValue({ image_id: selectedImage[0].filePath });
    } else {
      displayMessage(ERROR_MSG_TYPE, "Image not selected");
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage("");
    setSelectedFileValue(null);
    form.setFieldsValue({ image_id: "" });
  };

  const createData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("type", values.type);
    data.append("title", values.title);
    if (values.subtitle) data.append("subtitle", values.subtitle);
    if (values.ratting !== undefined && values.ratting !== null) {
      data.append("ratting", values.ratting);
    }
    if (values.short_description) {
      data.append("short_description", values.short_description);
    }
    data.append("external_link", values.external_link);
    data.append("status", values.status);

    if (selectedImage) {
      data.append("image_id", selectedImage);
    }
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/qr-sharing");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_QR_SHARING, data, successFn, errorFn);
  };

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Create QR Sharing Item"
            bordered={false}
            extra={
              <Button
                style={{ marginTop: "5px", marginBottom: "5px" }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loding}>
              <Form
                form={form}
                layout="vertical"
                onFinish={createData}
                initialValues={{ status: 1, type: "ratting" }}
              >
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="type"
                      label="Type"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="Select Type"
                        options={[
                          { label: "Rating", value: "ratting" },
                          { label: "OTA", value: "ota" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Title (e.g. Google)" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="subtitle" label="Subtitle">
                      <Input type={"text"} placeholder="Subtitle (e.g. Rate 5 Star)" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="ratting" label="Rating (0 - 5)">
                      <InputNumber
                        min={0}
                        max={5}
                        step={0.1}
                        style={{ width: "100%" }}
                        placeholder="e.g. 4.5"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={4}>
                    <Form.Item
                      type="file"
                      name="image_id"
                      label="Image / Logo"
                      rules={[{ required: true }]}
                    >
                      <Row>
                        <Col span={selectedImage === "" ? 24 : 15} offset={0}>
                          <Input
                            type="text"
                            readOnly
                            onClick={openDialog}
                            value={
                              selectedImage === ""
                                ? "Click to upload image"
                                : selectedImage
                            }
                            name="myImage"
                            placeholder="Image"
                          />
                        </Col>
                        {selectedImage !== "" ? (
                          <Col span={3} offset={1}>
                            <Badge>
                              <Avatar
                                src={IMAGE_BASE_URL + selectedFileValue}
                                shape="circle"
                                size="default"
                              />
                            </Badge>
                            <DeleteOutlined onClick={removeSelectedImage} />
                          </Col>
                        ) : null}
                      </Row>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="external_link"
                      label="External Link"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="https://..." />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name="status"
                      label="Status"
                      rules={[{ required: true }]}
                    >
                      <Select
                        options={[
                          { label: "Active", value: 1 },
                          { label: "Inactive", value: 0 },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item name="short_description" label="Short Description">
                      <Input.TextArea rows={3} placeholder="Short Description" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item style={{ float: "right" }} label="" colon={false}>
                      <Button loading={loding} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
        <ImageSelect
          isOpen={isDialogOpen}
          onClose={closeDialog}
          onOk={handleDialogOk}
          fromMager={false}
        />
      </Layout>
    </>
  );
}
export default QrSharingAdd;
